import { apiCallback } from 'api';

const definition = {
  service: 'term-suggest',
  endpoint: 'term-suggest/terms',
  query: {
    term: '${term}',
  },
  verbs: ['get'],
  defaultVersion: 1,
  headers: { 'search-engine-variant': 'unbxd' },
};

export default {
  get: apiCallback(definition, 'get'),
};
